import { useBusEmitterListener } from "./index";

const enabledChangedEvent = Symbol("bridge:enabledChanged");

export const {
  emitter: enabledChanged,
  listener: onEnabledChanged,
} = useBusEmitterListener<string>(enabledChangedEvent);
